import * as React from 'react';
import { FormattedLabelLink } from '../../../../../FormattedLabelLink/FormattedLabelLink.js';

const ProductBlockIncludesLensesLink = ({ tabIndex  })=>{
    return /*#__PURE__*/ React.createElement(FormattedLabelLink, {
        className: "v2-product-block-includes-lenses-link",
        labelKey: "products.glasses.offering.includesLenses",
        tabIndex: tabIndex
    });
};

export { ProductBlockIncludesLensesLink };
//# sourceMappingURL=ProductBlockIncludesLensesLink.js.map
